import { createAction } from 'typesafe-actions';

import { Actions as FPAIActions } from './constants';

interface InitiateFamilyPlanInviteeFlowParams {
  familyPlanInviteToken: $TSFixMe | null;
}

export const initiateFamilyPlanInviteeFlow = createAction(
  FPAIActions.INITIATE_FAMILY_PLAN_INVITEE_FLOW,
  (params: InitiateFamilyPlanInviteeFlowParams) => params,
)<InitiateFamilyPlanInviteeFlowParams>();
export type InitiateFamilyPlanInviteeFlowAction = ReturnType<typeof initiateFamilyPlanInviteeFlow>;

interface SetFamilyPlanInviteCodeParams {
  familyPlanInviteToken: $TSFixMe | null;
}

export const setFamilyPlanInviteCode = createAction(
  FPAIActions.SET_FAMILY_PLAN_INVITE_CODE,
  (params: SetFamilyPlanInviteCodeParams) => params,
)<SetFamilyPlanInviteCodeParams>();
export type SetFamilyPlanInviteCodeAction = ReturnType<typeof setFamilyPlanInviteCode>;

export const clearFamilyPlanInviteeFlow = (): SetFamilyPlanInviteCodeAction =>
  setFamilyPlanInviteCode({ familyPlanInviteToken: null });

export const familyChildContinueClicked = createAction(FPAIActions.FAMILY_CHILD_CONTINUE_CLICKED)();
export type FamilyChildContinueClickedAction = ReturnType<typeof familyChildContinueClicked>;
